import {
  Action,
  ActionType,
  IStressCheckDetailsResponse,
} from "models/stressCheck/stressCheckDetails";
import createReducer from "redux/createReducer";

export interface StressCheckDetailsReducerType {
  loading: boolean;
  error?: string;
  stressCheckDetailsResponse?: IStressCheckDetailsResponse;
}

const defaultState: StressCheckDetailsReducerType = {
  loading: false,
  error: undefined,
  stressCheckDetailsResponse: undefined,
};

export const stressCheckDetailsReducer =
  createReducer<StressCheckDetailsReducerType>(defaultState, {
    [ActionType.STRESS_CHECK_DETAILS](state: StressCheckDetailsReducerType) {
      return {
        ...state,
        loading: true,
      };
    },

    [ActionType.STRESS_CHECK_DETAILS_ERROR](
      state: StressCheckDetailsReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: action.payload,
        stressCheckDetailsResponse: undefined,
      };
    },

    [ActionType.STRESS_CHECK_DETAILS_SUCCESS](
      state: StressCheckDetailsReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        stressCheckDetailsResponse: action.payload,
      };
    },

    [ActionType.STRESS_CHECK_DETAILS_RESET_DATA](
      state: StressCheckDetailsReducerType
    ) {
      return {
        ...state,
        loading: false,
        error: null,
      };
    },
  });
